const apiUrl = process.env.REACT_APP_API_URL;

export default class Basketervice {
  // static loginData = localStorage.getItem('loginData')
  // ? JSON.parse(localStorage.getItem('loginData')!)
  // : {
  //   authChecked: false,
  //   loggedIn: false,
  //   token: ""
  // }
  static get() {
    return fetch(`${apiUrl}/api/basket/`, {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': `Bearer ${this.loginData.token}`,
      },
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static add(product: any) {
    return fetch(`${apiUrl}/api/basket/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': `Bearer ${this.loginData.token}`,
      },
      body: JSON.stringify(product),
    })
      .then((response) => response.json())
      .catch((error) => this.handleError(error));
  }

  static handleError(error: Error): void {
    console.error(error);
  }
}
